<template>
  <div id="free-trial">
    <!-- <div class="free-title">Subscribe to TVU Channel Service</div> -->
    <div
      class="free-container"
      v-if="!planisSub">
      <div class="channel-text">For One Channel</div>
      <div class="free">FREE</div>
      <div class="day">FOR {{this.day}} DAYS</div>
      <div class="info">After {{this.day}} days, your credit card will be charged <span class="free-price">${{ this.price / 100 }}</span> per channel per {{ cycle }}.</div>
      <div
        class="sub"
        v-if="!disableSub"
        @click="checkSub">
        Subscribe
      </div>
      <div
        class="sub has-sub"
        v-else>
        Subscribed
      </div>
    </div>

    <div
      v-if="planisSub"
      class="start-trial">
      <img
        class="all-right"
        src="@/assets/svg/allright.svg"
        alt="">
      <div
        class="start"
        v-if="planisSub">START TRIAL</div>
      <div
        class="start"
        v-if="planIsCharge">Your Subscription has been Modified</div>
      <div
        class="start"
        v-if="planIsPostPay">POST PAY COMPLETE</div>

      <!-- <div class="info" v-if="planisSub">After {{this.day}} days, your credit card will be charged $ {{ this.price / 100 }} per {{ cycle }}.</div> -->
      <div
        class="info"
        v-if="planisSub">
        <div class="sign-up">Thank you for signing up! </div>
        <div class="free-day">Your free trial will include access to a TVU Channel for {{this.day}} days without charge, after which you will be charged ${{ this.price / 100 }} USD per {{ cycle }} per channel. </div>
        <div class="free-detail">Any additional channels will cause your card to be charged immediately upon your confirmation.</div>
      </div>
      <div
        class="info"
        v-if="planIsCharge">Thank you, your subscription has been successfully modified, and the changes have been applied to your account. You may resume use.</div>
      <div
        class="info"
        v-if="planIsPostPay">Thank you, We will follow-up centralized deduction. You can start use it now.</div>

      <div class="trial-footer">
        <div
          class="close"
          @click="handleCloseIframe">
          Close
        </div>
      </div>
    </div>
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      width="360px"
      top="calc(15vh + 20px)"
      :modal="false"
      custom-class="free-dialog"
      >
      <img src="@/assets/svg/allright.svg" alt="">
      <div class="start" v-if="planisSub">START TRIAL</div>
      <div class="start" v-if="planIsCharge">Your Subscription has been Modified</div>
      <div class="start" v-if="planIsPostPay">POST PAY COMPLETE</div>

      <div class="info" v-if="planisSub">After {{this.day}} days, your credit card will be charged $ {{ this.price / 100 }} per {{ cycle }}.</div>
      <div class="info" v-if="planIsCharge">Thank you, your subscription has been successfully modified, and the changes have been applied to your account. You may resume use.</div>
      <div class="info" v-if="planIsPostPay">Thank you, We will follow-up centralized deduction. You can start use it now.</div>

    </el-dialog> -->

    <ConfirmPay
      v-if="showFreeConfirm"
      :price="price"
      :day="day"
      type="free"
      @handlePay="handleConfirm('free')"
      @handleClose="handleCloseDialog('free')" />
    <!-- <ConfirmPay v-if="showPayConfirm"  :price="price" :cycle="cycle"  type="pay" @handlePay="handleConfirm('pay')" @handleClose="handleCloseDialog('pay')"  /> -->
  </div>
</template>

<script>
import { GET_CUSTOMERPORTAL } from '../../queries'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import { userHasSubscription, handleNewSub, queryPrice } from '../../common/checkuser'
import ConfirmPay from '../ConfirmPay.vue'
// eslint-disable-next-line no-unused-vars
// const arr = ['Subscribe-click', 'Show-CustomerPortal', 'Show-PayDialog', 'PayDialog-confirm', 'PayDialog-cancle', 'Show-FreeDialog', 'FreeDialog-confirm', 'FreeDialog-cancle']
export default {
  name: 'FreeTrial',
  components: {
    ConfirmPay
  },
  props: {
    planDetail: {
      type: Object,
      default () {
        return {
          trialTime: 0,
          chargeCycle: '',
          metadata: '{}'
        }
      }
    }
  },
  data () {
    return {
      price: 0,
      // day: 0,
      // cycle: '',
      loading: false,
      error: false,
      // planDetail: null,
      dialogVisible: false, // 订阅之后的弹窗
      planisSub: false, // 订阅的支付方式
      planIsCharge: false, // 订阅的支付方式
      showFreeConfirm: false,
      showPayConfirm: false,
      planIsPostPay: false, // 订阅的支付方式
      disableSub: false // 订阅按钮是否禁用
    }
  },
  methods: {
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    handlecycle (cycle) {
      return cycle === 1 ? 'Week' : cycle === 2 ? 'month' : cycle === 3 ? 'Year' : ''
    },
    // 点击sub
    checkSub () {
      this.sendIframeMessage('Subscribe-click')
      // 查一下有没有 已经订阅
      this.querySubStatus(true)
    },
    // 去订阅
    subscriptionNow (type) {
      if (!this.planDetail.id) {
        setTimeout(() => {
          this.subscriptionNow()
        }, 2000)
      }
      const key = this.planDetail.chargeItems[0].addonId
      const chargeItems = {
        [key]: 1
      }
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel',
        planId: this.planDetail.id,
        description: `${this.planDetail.name} ${this.emailid} checkoutSubscription`,
        chargeItems: JSON.stringify(chargeItems)
      }
      handleNewSub(params, this).then(res => {
        if (res.info == 'POST-PAY') {
          this.showPayConfirm = false
          this.dialogVisible = true
          this.planIsPostPay = true
          this.querySubStatus(false, 'checksub')
          return
        }
        if (type === 'free') {
          this.showFreeConfirm = false
        } else if (type === 'pay') {
          this.showPayConfirm = false
        }
        this.dialogVisible = true
        this.querySubStatus(false, type)
      }).catch((err) => {
        this.showFreeConfirm = false
        this.showPayConfirm = false
        Message.error({
          message: err.info,
          duration: 5000
        })
        this.querySubStatus(false, 'checksub')
      })
    },

    // 订阅后 查询订阅状态
    querySubStatus (isOutside, type) {
      const params = {
        product: 'Tvuchannel'
      }
      userHasSubscription(params).then(({ data }) => {
        const subPlans = data.subscription.subscriptions || []
        // this.planisSub = subPlans.findIndex(i => i.planId === this.planDetail.id) > -1
        const item = subPlans.find(i => i.planId === this.planDetail.id)
        if (!item && isOutside) {
          // 没有订阅
          this.showFreeConfirm = true
          this.sendIframeMessage('Show-FreeDialog')
        } else if (type == 'free') {
          this.planisSub = !!item
        } else {
          // 已经订阅
          this.disableSub = !!item
        }
        //  0:订阅  1:订阅失败 2:cancel  3:试用

        // this.disableSub = item.status == 3 || item.status == 0
        // if(type === 'free') {
        //   this.planisSub = item && item.status == 3
        // }else if(type === 'pay') {
        //   this.planIsCharge = item && item.status == 0
        // }else
        // if(isOutside) {
        //   if(item && item.status == 2) {
        //     // 已经试用
        //     this.showPayConfirm = true
        //     this.sendIframeMessage('Show-PayDialog')
        //   }else{
        //     this.showFreeConfirm = true
        //     this.sendIframeMessage('Show-FreeDialog')
        //   }
        // }
      }).catch(err => {
        Message.error({
          message: err,
          duration: 5000
        })
      })
    },
    // 确认订阅
    handleConfirm (type) {
      // this.showFreeConfirm = false
      if (type == 'free') {
        this.sendIframeMessage('FreeDialog-confirm')
      } else if (type == 'pay') {
        this.sendIframeMessage('PayDialog-confirm')
      }
      this.subscriptionNow(type)
    },
    // 获取customerPortal
    handlecustomerPortal () {
      this.$apollo.query({
        query: GET_CUSTOMERPORTAL,
        variables: {
          customerId: this.emailid,
          product: 'Tvuchannel'
        }
      }).then(({ data }) => {
        this.openCustomerPortal(data.customerPortal.url)
      })
    },
    // 打开 customerPortal
    openCustomerPortal (url) {
      const cbInstance = window.Chargebee.getInstance()
      cbInstance.openCheckout({
        hostedPage: () => new Promise((resolve) => resolve({ url }))
      })
    },
    handleCloseDialog (type) {
      if (type == 'free') {
        this.showFreeConfirm = false
        this.sendIframeMessage('FreeDialog-cancle')
      } else if (type == 'pay') {
        this.showPayConfirm = false
        this.sendIframeMessage('PayDialog-cancle')
      }
    },
    // 发送消息
    sendIframeMessage (key) {
      const params = {
        type: 'step',
        data: {
          type: 'Event-Google-Analytics',
          key
        }
      }
      window.parent.postMessage(params, '*')
    },
    // 查询价格
    handleQueryPrice () {
      const params = {
        customerId: this.emailid,
        product: 'Tvuchannel',
        planId: this.planDetail.id
      }
      queryPrice(params).then(res => {
        this.price = res.data.previewCustomSubscription.price
      })
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email
    }),
    //       this.cycle = this.handlecycle(this.planDetail.chargeCycle)
    //       this.price = JSON.parse(this.planDetail.metadata).price
    //       this.day = this.planDetail.trialTime / 86400
    cycle () {
      this.handleQueryPrice()
      return this.handlecycle(this.planDetail.chargeCycle)
    },
    // price () {
    //   return JSON.parse(this.planDetail.metadata).price
    // },
    day () {
      return this.planDetail.trialTime / 86400
    }
  }
}
</script>

<style lang="less" scoped>
#free-trial {
  width: 100%;
  text-align: center;
  // margin-top: 20vh;
  // margin-top: 50px;
  .free-title{
    font-size: 36px;
    font-weight: 500;
    // height: 36px;
    line-height: 36px;
    margin: 30px 0;
  }
  .free-container {
    text-align: center;
    .channel-text {
      font-weight: 400;
      line-height: 16px;
      color: #888888;
    }
    .free {
      font-weight: 700;
      font-size: 48px;
      line-height: 48px;
      color: #7CC855;
      margin: 30px 0;
    }
    .day {
      font-weight: 700;
      font-size: 30px;
      line-height: 30px;
      color: #888888;
      margin: 10px 0;
    }
    .info {
      width: 80%;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      line-height: 20px;
      color: #9B9CA2;
      margin: 50px auto;
      word-break: break-word;
      .free-price {
        color: #DA7C31;
      }
    }
    .sub{
      // margin-top: 20px;
      margin: 120px auto 30px;
      background: #33AB4F;
      width: 164px;
      height: 28px;
      line-height: 28px;
      font-size: 18px;
      padding: 10px 16px;
      border-radius: 30px;
      color: #fff;
      cursor: pointer;
      user-select: none;
    }
    .has-sub {
      background: #ab6363;
    }
  }
  .start-trial {
    .all-right {
      margin: 20px auto;
    }
    .start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #444444;
    }
    .info {
      width: 90%;
      margin: 10px auto;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #979797;
      word-break: break-word;
      .sign-up {
        color: #7CC855;
      }
      .free-day {
        margin: 10px;
      }
    }
    .trial-footer {
      margin: 60px 0 0 ;
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      .close {
        width: 60px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
      }
    }
  }
}
/deep/ .free-dialog {
  height: 275px;
  border-radius: 15px;
  .start {
    color: #000;
    font-weight: 700;
    margin: 10px 0;
  }
  .info {
    width: 200px;
    margin: 0 auto;
    font-weight: 400;
    color: #979797;
    font-size: 14px;
    line-height: 16px;
    word-break: break-word;
  }
  .el-icon-close {
    color: #979797;
  }
}
</style>
